import React from 'react';
import { twMerge } from 'tailwind-merge';
import ButtonComponent from 'components/button/buttonComponent';

interface IRecommendedProductCardProps {
  title: string;
  amount: number;
  total: number;
  isPurchase?: boolean;
  isProvider: boolean;
  loading: boolean;
  onPurchase: () => void;
}

const RecommendedProductCard: React.FC<IRecommendedProductCardProps> = ({
  title,
  amount,
  total,
  isPurchase = true,
  isProvider,
  loading,
  onPurchase,
}) => {
  return (
    <div className="desktop:px-5 desktop:py-3 px-3 py-1.5 border border-gray-opacity-15 rounded-10 gap-2 desktop:gap-2.5 bg-base-content flex desktop:flex-row flex-col items-center ">
      <div className="flex flex-col w-full desktop:flex-row justify-start desktop:items-center desktop:gap-2.5">
        <span className="text-neutral-800 font-semibold text-base desktop:whitespace-nowrap">
          {title}
        </span>
        <div className="flex gap-2.5">
          <span className="text-med-gray-3 font-medium text-sm whitespace-nowrap">{`Qty: ${amount} test`}</span>
          <span className="desktop:hidden desktop:text-base text-sm font-semibold text-neutral-800">
            Total: ${total}
          </span>
        </div>
      </div>
      <div className="flex w-full desktop:ml-auto desktop:flex-row flex-col desktop:justify-end desktop:items-center gap-2.5 desktop:gap-4">
        <div
          className={twMerge(
            'text-sm font-semibold w-fit text-bright-green border rounded-full border-bright-green bg-green-50 px-2.5',
            !isPurchase && 'hidden',
          )}
        >
          Purchased
        </div>
        <span className="desktop:block hidden text-base font-semibold text-neutral-800">
          Total: ${total}
        </span>
        <ButtonComponent
          className={twMerge('!text-sm', isProvider && 'hidden')}
          testID="purchase"
          disabled={loading}
          showSpinner={loading}
          onClick={onPurchase}
        >
          Get test kit
        </ButtonComponent>
      </div>
    </div>
  );
};

export default RecommendedProductCard;
